import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {ACTIVE_SEARCH_SET, SEARCH_RESULT_ADD, SEARCH_RESULT_REMOVE, SEARCH_RESULT_UPDATE, ShipmentRemove} from '@store/actions';
import {AppState, SearchResult, selectFooterAction, selectSearchResults, selectUser} from '@store/reducers';
import {AccountService} from '@services/account.service';
import {Store} from '@ngrx/store';
import {PackageDetailsService} from '@services/package-details.service';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {takeUntil} from 'rxjs/operators';
import {RemoveShipments} from '@store/actions/shipments.action';
import {ShipmentTypes} from '@store/reducers/shipments.reducer';
import {UUID} from 'angular2-uuid';
import {NumberFormatPipe} from '@pipes/number-fomat.pipe';
import {FooterActionEnum} from '@models/footer-action.enum';

import {DateFormatPipe} from '@pipes/date-format.pipe';
import {User} from '@models/user.interface';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-saved-shipments',
  template: `
    <app-shipment-table *ngIf="shipmentsState"
      [shipmentType]="shipmentTypes.SAVED"
      [rows]="rows"
      [data]="generateData(data) | async"
      [checkboxSign]="true"
      [deleteSign]="true"
      [totalShipmentsLength]="totalShipmentsLength"
      [currentPageSize]="currentPageSize"
      [currentPage]="currentPage"
      (selectRow)="handleSelectRow($event)"
      (changePage)="handleChangePage($event)"
      (deleteElement)="handleDeleteMany([$event])"
    ></app-shipment-table>
  `
})

export class SavedShipmentsComponent implements OnInit, OnDestroy {
  shipmentTypes = ShipmentTypes;
  rows = [
    {label: this.translate.instant('account.section.shipment.saved.table.header1'), value: 'consignor'},
    {label: this.translate.instant('account.section.shipment.saved.table.header2'), value: 'consignee'},
    {label: this.translate.instant('account.section.shipment.saved.table.header3'), value: 'goods_summary'},
    {label: this.translate.instant('account.section.shipment.saved.table.header4'), value: 'ready_for_pickup'},
  ];

  private user: User;
  private searchResults: SearchResult[];
  private unsubscribe: Subject<void> = new Subject();

  @Input() shipmentsState: any;
  @Input() data: any;
  @Input() currentPage: number;
  @Input() currentPageSize: number;
  @Input() totalShipmentsLength: number;

  @Output() onChangePage: EventEmitter<any> = new EventEmitter();

  constructor(
    public faService: FontAwesomeService,
    private accountService: AccountService,
    private store: Store<AppState>,
    private packageDetailsService: PackageDetailsService,
    private translate: TranslateService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.store.select(selectFooterAction)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(action => {
        if (action === FooterActionEnum.DELETE_SELECTED_SHIPMENTS) {
          this.handleDeleteMany(this.selectedShipmentIds);
        }

        if (action === FooterActionEnum.GO_TO_CREATE_CONSIGNMENT_SEARCH_RESULT) {
          this.removeAllShipmentsFromState();
          this.selectedShipments
            .forEach(shipment => this.addSearchResult(shipment, true, shipment.id, UUID.UUID()));
          this.router.navigate(['create-consignment', 'search-result']);
        }
      });

    /*
    this.store.select(selectSearchResults)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => this.searchResults = data);

    this.searchResults.forEach(result => {
      this.store.dispatch(new ShipmentRemove({id: result.id}));
    });

    this.searchResults = [];
    console.log(this.searchResults);
    */

  }

  removeAllShipmentsFromState() {
    this.store.select(selectSearchResults)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => this.searchResults = data);

    this.searchResults.forEach(result => {
      this.store.dispatch({
        type: SEARCH_RESULT_REMOVE,
        payload: {
          id: result.id
        }
      });
      this.store.dispatch(new ShipmentRemove({id: result.id}));
    });
  }

  get selectedShipmentIds () {
    const ids = [];
    Object.keys(this.shipmentsState.data[this.currentPageSize])
      .forEach(key => {
        this.shipmentsState.data[this.currentPageSize][key]
          .forEach(({selected, id}) => {
            if (selected) {
              ids.push(id);
            }
          });
      });
    return ids;
  }

  get selectedShipments () {
    const shipments = [];
    Object.keys(this.shipmentsState.data[this.currentPageSize])
      .forEach(key => {
        this.shipmentsState.data[this.currentPageSize][key]
          .forEach(shipment => {
            if (shipment.selected) {
              shipments.push(shipment);
            }
          });
      });
    return shipments;
  }

  addSearchResult(shipment, saved, search_id, id) {
    /*
    const existingSearchResult: SearchResult =
      this.searchResults.find(searchResult => searchResult.search_id == search_id);
    if (existingSearchResult) {
      this.store.dispatch({
        type: SEARCH_RESULT_UPDATE,
        payload: {
          params: shipment.search,
          id: existingSearchResult.id,
          search_id,
          products: [],
          loading: true,
          loaded: false,
          saved,
        },
      });
    } else {
    */
      this.store.dispatch({
        type: SEARCH_RESULT_ADD,
        payload: {
          params: shipment.search,
          id,
          reference: shipment.search.reference !== undefined ? shipment.search.reference : null,
          search_id,
          products: [],
          loading: true,
          loaded: false,
          saved
        },
      });
    // }
  }

  handleChangePage(current_page) {
    this.onChangePage.emit(current_page);
  }
  generateData(shipments) {
    if (!shipments || (shipments && !shipments.length)) {
      return Observable.of([]);
    }
    return this.translate.get(`common.packageType.${shipments[0].search.packages[0].type}`)
      .map(packageType => {
        return shipments.map(({search: {reference, from, to, packages, pickup_date, pickup_time}, id, selected}) => {
          const packagesDetails = this.packageDetailsService.getTotalPackagesData(packages, false);
          const type = this.translate.instant(`common.packageType.${packagesDetails.type}`);
          return {
            id,
            reference: reference !== undefined ? reference : null,
            consignor: `${from.zip}, ${from.city.toUpperCase()}, ${from.country_code.toUpperCase()}`,
            consignee: `${to.zip}, ${to.city.toUpperCase()}, ${to.country_code.toUpperCase()}`,
            goods_summary:
              `${packagesDetails.quantity} ${type},
               ${(new NumberFormatPipe(null)).transform(packagesDetails.volume, '1.0-4', this.translate.currentLang)}
                m<sup>3</sup> ${packagesDetails.weight} kg`,
            ready_for_pickup: !pickup_date ? this.translate.instant('common.notSet') :
              `${(new DateFormatPipe(this.translate))
              .transform(pickup_date + ' ' + pickup_time + ':00', 'mediumDate', 'shortTime', this.translate.currentLang)}`,
            selected
          };
        });
      }).pipe(takeUntil(this.unsubscribe));
  }

  handleDeleteMany(ids: number[]) {
    this.store.dispatch(new RemoveShipments({
      type: ShipmentTypes.SAVED,
      ids,
      current_page_size: this.currentPageSize,
      current_page: this.currentPage
    }));
  }

  handleSelectRow(search_id) {
    let shipment = this.data.find(({id}) => id === search_id);
    // console.log(shipment);
    /*
    const existingSearchResult: SearchResult =
      this.searchResults.find(searchResult => searchResult.search_id == search_id);
      */
    const id = UUID.UUID();

    shipment = {
      ...shipment,
      search_id,
      id
    };
    this.store.dispatch({
      type: ACTIVE_SEARCH_SET,
      payload: {
        // activeSearchId: (existingSearchResult && existingSearchResult.id) || shipment.id
        activeSearchId: shipment.id
      }
    });
    this.addSearchResult(shipment, false, search_id, id);
    this.router.navigate(['create-consignment']);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/saved-shipments/saved-shipments.component.ts